import {
  getAllPrivateCourses,
  saveRegistration,
  completeRegistration,
  updatePaymentOrderFailed
} from './api'
import { registerSlice } from './reducer'

const { updateOtp, updateHasError, updateOtpModel, updateCourse, reset } =
  registerSlice.actions

export {
  getAllPrivateCourses,
  saveRegistration,
  updateOtp,
  updateHasError,
  updateOtpModel,
  completeRegistration,
  updateCourse,
  updatePaymentOrderFailed,
  reset as resetRegisterState
}
